// storeTypes.js — mirror DealCouponz client naming style

export const FETCH_STORES_REQUEST = "FETCH_STORES_REQUEST";
export const FETCH_STORES_SUCCESS = "FETCH_STORES_SUCCESS";
export const FETCH_STORES_FAILURE = "FETCH_STORES_FAILURE";

export const LOAD_STORE_PAGE_REQUEST = "LOAD_STORE_PAGE_REQUEST";
export const LOAD_STORE_PAGE_SUCCESS = "LOAD_STORE_PAGE_SUCCESS";
export const LOAD_STORE_PAGE_FAILURE = "LOAD_STORE_PAGE_FAILURE";
